import React from "react";
import BaseModal from "../BaseModal";

function GameLostModal({ open }) {

  return (
    <BaseModal
      title="You lost. Will you marry me anyway?"
      initiallyOpen={open}
      showActionButton={false}
    >
      <div className="grid gap-y-2">
        <p className="text-lg font-[500] text-center">
          I don't know what went wrong with this but I'm hoping for a yes anyway!
        </p>
      </div>
    </BaseModal>
  );
}

export default GameLostModal;
